module.exports = __webpack_public_path__ + "static/media/checkbox-2.37b21b36.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/checkbox-2.svg
// module id = ./src/assets/images/checkbox-2.svg
// module chunks = 0